import React from 'react';
import { GoogleLogin } from '@react-oauth/google';
import { useGoogleAuth } from '../services/api/queries';
import { StringParam, useQueryParam } from 'use-query-params';
import { addOptionalQueryParam } from 'web/utils/request';

type GoogleLoginButtonProps = {
    preSuccess?: (token: string) => boolean;
    onSuccess?: (token: string) => void;
    onError?: (error: string) => void;
    className?: string;
};

export const GoogleLoginButton: React.FC<GoogleLoginButtonProps> = ({ 
    preSuccess,
    onSuccess,
    onError,
    className
}) => {
    const { mutate: googleAuth, isLoading } = useGoogleAuth();
    const [invitationCode] = useQueryParam('inv', StringParam);

    return (
        <div className={`w-full flex justify-center ${className || ''}`}>
            <GoogleLogin
                onSuccess={(credentialResponse) => {
                    if (credentialResponse.credential) {
                        googleAuth(
                            { token: credentialResponse.credential },
                            {
                                onSuccess: ({ token }) => {
                                    if (preSuccess && !preSuccess(token)) {
                                        return;
                                    }

                                    if (onSuccess) {
                                        onSuccess(token);
                                    } else if (token) {
                                        let signupUrl = '/signup';
                                        signupUrl = addOptionalQueryParam(signupUrl, 'inv', invitationCode);
                                        signupUrl = addOptionalQueryParam(signupUrl, 'token', token);
                                        window.location.href = signupUrl;
                                    } else {
                                        window.location.href = '/';
                                    }
                                },
                                onError: (error) => {
                                    if (onError) {
                                        onError(typeof error === 'string' ? error : 'Failed to authenticate with Google');
                                    }
                                },
                            }
                        );
                    }
                }}
                onError={() => {
                    if (onError) {
                        onError('Google authentication failed');
                    }
                }}
                theme="outline"
                size="large"
                text="continue_with"
                width="280"
            />
            {isLoading && <div className="absolute inset-0 bg-white bg-opacity-50 flex items-center justify-center">Loading...</div>}
        </div>
    );
};

export default GoogleLoginButton;
